import { IAdvertiserState } from "advertiser/model"
import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { Action, Reducer } from "redux"
import { IAdvertiserAdd, IAdvertiserSetList, IAdvertiserUpdate } from "./actions"
import { getDefaultAdvertiserState } from "./state"

export const advertiserReducer: Reducer<IAdvertiserState, Action> = (
  state: IAdvertiserState | undefined,
  action: Action
): IAdvertiserState => {
  if (!state) {
    state = getDefaultAdvertiserState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { advertisers, advertiserDomains } = action as IAppActionInitData
      return {
        ...state,
        advertisers,
        advertiserDomains
      }
    }

    case ACTIONS.ADVERTISER_ADD: {
      const { advertiser } = action as IAdvertiserAdd
      return {
        ...state,
        advertisers: [...state.advertisers, advertiser]
      }
    }

    case ACTIONS.ADVERTISER_UPDATE: {
      const { advertiser } = action as IAdvertiserUpdate
      return {
        ...state,
        advertisers: state.advertisers.map(a => (a.id === advertiser.id ? advertiser : a))
      }
    }

    case ACTIONS.ADVERTISER_SET_LIST: {
      const { list } = action as IAdvertiserSetList
      return {
        ...state,
        list: {
          ...state.list,
          ...list
        }
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultAdvertiserState()
    }

    default:
      return state
  }
}
